import Vue from 'vue'
import router from './router'
import App from './App.vue'
import VueGtm from '@gtm-support/vue2-gtm'
import VueRouter from 'vue-router'
// import store from './store'
import componentId from '@/helpers/componentId'
import { BootstrapVue } from 'bootstrap-vue'
import '@/assets/styles/main.scss'
import { createPinia, PiniaVuePlugin } from 'pinia'

import * as Sentry from '@sentry/vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

Sentry.init({
  Vue,
  dsn: null,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/core\.relancer\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  logErrors: true,
})

function getUser () {
  const user = (JSON.parse(window.localStorage.getItem('auth') || '{}') || {}).user
  if (user && user.businesses) {
    delete user.businesses
  }
  return user
}

Sentry.configureScope(scope => {
  scope.setExtra('version', window.localStorage.getItem('version'))
  scope.setExtra('user', getUser())
})

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)

// Vue gtm & google analytics
Vue.use(VueGtm, {
  id: 'GTM-54GP8NJ',
  enabled: import.meta.NODE_ENV === 'production' || process.env.NODE_ENV === 'production',
})

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

Vue.use(VueRouter)

Vue.mixin(componentId)

Vue.config.productionTip = false

const CURRENT_VERSION = '3.6'

if (!window.localStorage.version || window.localStorage.version !== CURRENT_VERSION) {
  window.localStorage.clear()
  window.localStorage.version = CURRENT_VERSION
  window.location.reload()
}

// Set UTM_* data to cookies for signup
const url = new URL(window.location.href)
if (url.searchParams.get('utm_source')) {
  setCookie('utm_source', url.searchParams.get('utm_source'))
}
if (url.searchParams.get('utm_medium')) {
  setCookie('utm_medium', url.searchParams.get('utm_medium'))
}

export default new Vue({
  router,
  // store,
  pinia,
  render: h => h(App),
}).$mount('#app')

function setCookie (cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires
}
